<template>
  <div class="com">
    <button class="close" @click="closeModal">
      <CloseIcone></CloseIcone>
    </button>
    <div class="button-container">
      <button class="print-btn" @click="callPrint">Print</button>
      <button class="print-btn" style="margin-left:10px;" v-show="kit.status === 'lab_awaiting' && !enableEdit" @click="editDetails">Edit</button>
      <button class="print-btn" style="margin-left:10px;" v-show="kit.status === 'lab_awaiting' && enableEdit" @click="cancelEdit">Cancel</button>
      <button class="print-btn" style="margin-left:10px;" @click="toggleLog" v-show="kit.status === 'lab_awaiting' && !showLog" >Show log</button>
      <button class="print-btn" style="margin-left:10px;" @click="toggleLog" v-show="kit.status === 'lab_awaiting' && showLog">Back</button>
      <span class="share-span">
        <img
            class="share-btn-img"
            src="../../images/dashboard/icons8-share.png"
            alt="#"
            @click="shareStatus"
          />
      </span>
    </div>
    <div v-show="!showLog">
      <div class="title">
        <span>Test Kit Tracking</span>
        <div class="id">
          <span style="padding: 1.5px 0 0 0">KIT ID:</span>
          <input
            :readonly="readonly"
            class="kit-input"
            type="text"
            name="kit_id"
            v-validate = "{ required: true, length: 20 }"
            v-model = "convertedKitId"
            v-mask = "'XX - XX - XXX - XXXX'"
          />
        </div>
        <span class="validate-error right" v-if="errors.has('kit_id')">{{
          errors.first("kit_id")
        }}</span>
      </div>
      <Timelinenew
        :kit="kit"
      />
      <div class="title">
        <span>Test Kit Information</span>
      </div>
      <div class="proj-wrap">
        <div class="col">
          <div class="item">
            <div class="item-title">Project Name</div>
            <div class="item-val" v-if="kit.title !== null">
              <div class="input-wrap"  v-if="enableEdit">
                <input
                  type="text"
                  v-model="title"
                  v-validate="'required|max:100'"
                  class="input"
                  name="title"
                  placeholder="Project Name"
                />
                <span class="validate-error zip" v-if="errors.has('title')">
                  {{ errors.first("title") }}
                </span>
              </div>
              <span v-else>
                {{ kit.title }}
              </span>
            </div>
            <div class="item-val noData" v-else>No Data</div>
          </div>
        </div>
        <div class="col">
            <div class="item">
              <div class="item-title">Shipment Tracking</div>
              <div class="item-val">
                To Customer:&nbsp; 
                <span v-if="shipmentStatus !== null"> 
                    <a target="_blank" :href="`${wp_api_url}order_id=${kit.order_number}&order_key=${kit.orderKey}`" class="btn-link">
                    {{shipmentStatus}} 
                    </a>
                </span>
                <span v-else>
                  No Tracking Data
                </span>
                .&nbsp; To Lab:&nbsp; 
                <span v-if="track_number !== null && ship_method !== null">
                  <a target="_blank"  v-if="ship_method = 'USPS'" :href="`https://tools.usps.com/go/TrackConfirmAction?tRef=fullpage&tLc=2&text28777=&tLabels=${track_number}%2C&tABt=true`" class="btn-link">
                  Track.
                  </a>
                  <a target="_blank"  v-else-if="ship_method = 'DHL'" :href="`https://webtrack.dhlglobalmail.com/orders?trackingNumber=${track_number}`" class="btn-link">
                  Track.
                  </a>
                  <a target="_blank"  v-else-if="ship_method = 'FEDEX'" :href="`https://www.fedex.com/fedextrack/?trknbr=${track_number}`" class="btn-link">
                  Track.
                  </a>
                  <a target="_blank"  v-else-if="ship_method = 'UPS'" :href="` https://www.ups.com/track?track=yes&trackNums=${track_number}&loc=en_US&requester=ST/`" class="btn-link">
                  Track.
                  </a>
                </span>
                <span v-else>
                    No Tracking Data.
                </span>
              </div>
            </div>
         </div>
        </div>
        <div class="date-wrap">
          <div class="col">
            <div class="item">
              <div class="item-title">Ship Date</div>
              <div class="item-val" v-if="kit.shipped_at !== null">
                  {{ date(kit.shipped_at) }}
              </div>
              <div class="item-val noData" v-else>No Data</div>
            </div>
            <div class="item">
              <div class="item-title">Status</div>
              <div class="status-wrap" v-click-outside="closeModel">
                <div class="item-val status">
                  <span
                    class="item-val-span hold"
                    v-if="selectedStatus === 'on_hold'"
                    style="color: #E87A01;"
                  >
                    <span class="circle" style="background-color: #E87A01;"></span>
                    On Hold
                  </span>
                  <button
                    class="onhold-btn"
                    v-if="kit.status === 'on_hold' && selectedStatus === 'on_hold'"
                    @click.stop="stopPropagation"
                    @click="showComment"
                  >
                    <img
                      class="onhold-btn-img"
                      src="../../images/dashboard/onhold.png"
                      alt="#"
                    />
                  </button>
                  <span
                    class="item-val-span"
                    v-if="selectedStatus === 'analysis_completed'"
                  >
                    <span class="circle green"></span>Analysis Complete
                  </span>
                  <span class="item-val-span" v-if="selectedStatus === 'analysis_failed'">
                    <span class="circle red"></span>Analysis Failed
                  </span>
                  <span class="item-val-span" v-if="selectedStatus === 'partially_failed'">
                    <span class="circle green"></span>Analysis Partially Complete
                  </span>
                  
                  <span
                    class="item-val-span"
                    @click="showDropDownFn"
                    v-if="selectedStatus === 'lab_awaiting'"
                  >
                    <span class="circle purple"></span>Submitted
                    <img
                      class="item-val-img"
                      src="../../images/dashboard/statusDrop.png"
                      alt="#"
                    />
                  </span>
                  <span
                    class="item-val-span"
                    @click="showDropDownFn"
                    v-if="selectedStatus === 'lab_received'"
                  >
                    <span class="circle orange"></span>Lab Received
                    <img
                      class="item-val-img"
                      src="../../images/dashboard/statusDrop.png"
                      alt="#"
                    />
                  </span>
                  <span class="item-val-span" v-if="selectedStatus === 'shipped'">
                    <span class="circle blue"></span> Shipped
                  </span>
                  <span class="item-val-span" v-if="selectedStatus === 'delivered'">
                    <span class="circle skyblue"></span> Delivered
                  </span>
                  <div class="filter-wrap" v-click-outside="closeDropDown">
                    <span
                      class="item-val-span"
                      @click="showSelectDropFn"
                      v-if="selectedStatus === 'archive'"
                    >
                      <span class="circle orange"></span>Archived
                      <img
                        class="item-val-img"
                        src="../../images/dashboard/statusDrop.png"
                        alt="#"
                      />
                    </span>
                      <ul class="filter-list-wrap"  v-show="showSelectDrop">
                        <li class="filter-list-item hide">Status</li>
                        <li
                          class="filter-list-item"
                          @click="setItem(0)"
                        >
                          Shipped
                        </li>
                        <li
                          class="filter-list-item"
                          @click="setItem(6)"
                        >
                          Delivered
                        </li>
                        <li
                          class="filter-list-item"
                          @click="setItem(1)"
                        >
                          Activated
                        </li>
                        <li
                          class="filter-list-item"
                          @click="setItem(2)"
                        >
                          Submitted
                        </li>
                        <li
                          class="filter-list-item"
                          @click="setItem(3)"
                        >
                          Lab Received
                        </li>
                        <li
                          class="filter-list-item"
                          @click="setItem(4)"
                        >
                          On Hold
                        </li>

                        <li
                          class="filter-list-item"
                          @click="setItem(5)"
                        >
                          Analysis Complete
                        </li>
                      </ul>
                  </div>
                  <span
                    class="item-val-span"
                    @click="showDropDownFn"
                    v-if="selectedStatus === 'activated'"
                  >
                    <span class="circle"></span>Activated
                    <img
                      class="item-val-img"
                      src="../../images/dashboard/statusDrop.png"
                      alt="#"
                    />
                  </span>
                </div>
                <ul class="dropDown" v-show="showDropDown">
                  <li
                    v-for="item in status"
                    v-bind:key="item"
                    class="dropDown-item"
                    :class="[
                      { undisabled: selectedStatus === 'shipped' && item === 1 },
                      { undisabled: selectedStatus === 'activated' && item === 2 },
                      {
                        undisabled: selectedStatus === 'lab_awaiting' && item === 3
                      },
                      {
                        undisabled:
                          selectedStatus === 'lab_received' &&
                          (item === 4 || (item === 5 && upload))
                      }
                    ]"
                  >
                    <span v-if="item === 0" @click="setItem(item)">Shipped</span>
                    <span v-if="item === 1" @click="setItem(item)">Activated</span>
                    <span v-if="item === 6" @click="setItem(item)">
                      Delivered
                    </span>
                    <span v-if="item === 2" @click="setItem(item)">
                      Submitted
                    </span>
                    <span v-if="item === 3" @click="setItem(item)">
                      Lab Received
                    </span>
                    <span v-if="item === 4" @click="setItem(item)">On Hold</span>
                    <span v-if="item === 5" @click="setItem(item)">
                      Analysis Complete
                    </span>
                    <span v-if="item === 10" @click="setItem(item)">
                      Analysis Failed
                    </span>
                    <span v-if="item === 11" @click="setItem(item)">
                      Analysis Partially Complete
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="item">
              <div class="item-title">Send Report Copy To</div>
              <div class="item-val" v-if="kit.report_forward_email !== null">
                {{ kit.report_forward_email }}
              </div>
              <div class="item-val noData" v-else>
                N/A
              </div>
              <!-- <div class="item-val">
                <input
                        type="text"
                        class="input toLowerCase"
                        name="report_forward_email"
                        placeholder="Email Address"
                        v-model="report_forward_email"
                        style="width: 50%;"
                      />
                      <button class="print-btn-email"  @click.prevent="savereportemails">Send</button>        
              </div> -->
            </div>
            <div class="item" v-if="selectedStatus === 'archive'">
              <div class="item-title">Archive Date</div>
              <div class="item-val" v-if="kit.archived_at !== null">
                  {{ date(kit.archived_at) }}
              </div>
              <div class="item-val noData" v-else>No Data</div>
            </div>
          </div>
          <div class="col">
            <div class="item">
              <div class="item-title">Date of Submission</div>
              <div class="item-val" v-if="kit.submission_at !== null">
                {{ date(kit.submission_at) }}
              </div>
              <div class="item-val noData" v-else>No Data</div>
            </div>
            <div class="item">
              <div class="item-title">Date of Activation</div>
              <div class="item-val" v-if="kit.activated_at !== null">
                {{ date(kit.activated_at) }}
              </div>
              <div class="item-val noData" v-else>No Data</div>
            </div>
          </div>
        </div>
        <div class="location">
          <div class="col">
            <div class="item">
              <div class="item-title">Sampling Location</div>
              <div class="item-val" v-if="kit.zip !== null">
                <div class="input-wrap"  v-if="enableEdit">
                  <input
                    type="text"
                    v-model="address"
                    v-validate="'required|max:100'"
                    class="input"
                    name="title"
                    placeholder="Project Name"
                  />
                  <span class="validate-error zip" v-if="errors.has('title')">
                    {{ errors.first("title") }}
                  </span>
                </div>
                <span v-else>
                  {{ kit.address }}, {{ kit.city }}, {{ kit.state }} {{ kit.zip }}
                </span>
              </div>
              <div class="item-val noData" v-else>No Data</div>
            </div>
          </div>
          <div class="col">
            <div class="item">
              <div class="item-title">Sampling Date</div>
              <div class="item-val" v-if="kit.sampling_date !== null">
                <div class="datepickerWrapDiv"  v-if="enableEdit">
                  <Datepicker
                    :disabledDates="{ from: serverTime }"
                    placeholder="Select Date"
                    v-model="sampling_date"
                    name="activated_at"
                    v-validate="'required'"
                    :format="formatDate"
                    :calendar-class="{ calendarWrap: true }"
                    :class="{ datepickerWrap: true }"
                    :input-class="{ datepickerInput: true, error: dateError }"
                  ></Datepicker>
                </div>
                <span v-else>
                {{ date(kit.sampling_date) }}
                </span>
              </div>
              <div class="item-val noData" v-else>No Data</div>
            </div>
          </div>
        </div>
        <div class="details answers-border">
          <div class="details-title">ANSWERS TO QUESTIONS</div>
          <div class="item-val">
            Visible mold:
            <div class="checkbox-items-wrap" v-if="enableEdit">
              <div class="label-checkbox">
                <div class="checkbox-wrap">
                  <label
                    for="check1"
                    class="checkbox-toggle-text"
                    :class="{ 'checkbox-toggle-text-right': !visible_mold }"
                    >{{ visible_mold ? "Yes" : "No" }}</label
                  >
                  <input
                    type="checkbox"
                    class="checkbox"
                    id="check1"
                    v-model="visible_mold"
                  />
                  <span class="slider"></span>
                </div>
              </div>
            </div>
            <span v-else>
              <b class="answer">{{
                  kit.visible_mold === true
                    ? "Yes"
                    : kit.visible_mold === false
                    ? "No"
                    : "No Data"
                }}</b>
            </span>
            "Musty" or a "damp":
            <div class="checkbox-items-wrap" v-if="enableEdit">
              <div class="label-checkbox">
                <div class="checkbox-wrap">
                  <label
                    for="check2"
                    class="checkbox-toggle-text"
                    :class="{ 'checkbox-toggle-text-right': !musty_damp_odor }"
                    >{{ musty_damp_odor ? "Yes" : "No" }}</label
                  >
                  <input
                    type="checkbox"
                    class="checkbox"
                    id="check2"
                    v-model="musty_damp_odor"
                  />
                  <span class="slider"></span>
                </div>
              </div>
            </div>
            <span v-else>
            <b class="answer">{{
              kit.musty_damp_odor === true
                ? "Yes"
                : kit.musty_damp_odor === false
                ? "No"
                : "No Data"
            }}</b>
            </span>
            Symptoms:
            <div class="checkbox-items-wrap" v-if="enableEdit">
              <div class="label-checkbox">
                <div class="checkbox-wrap">
                  <label
                    for="check3"
                    class="checkbox-toggle-text"
                    :class="{ 'checkbox-toggle-text-right': !symptoms }"
                    >{{ symptoms ? "Yes" : "No" }}</label
                  >
                  <input
                    type="checkbox"
                    class="checkbox"
                    id="check3"
                    v-model="symptoms"
                  />
                  <span class="slider"></span>
                </div>
              </div>
            </div>
            <span v-else>
              <b class="answer">{{
                kit.symptoms === true
                  ? "Yes"
                  : kit.symptoms === false
                  ? "No"
                  : "No Data"
              }}</b>
            </span>
          </div>
        </div>
        <div class="details">
          <div class="col">
            <div>
              <div class="item-title">Outdoor Sample</div>
              <div class="row" v-if="kit.outdoor_sample !== null">
                <div class="row-item-out">
                  <div class="inputs-wrap outdoor" v-if="enableEdit" >
                  <input
                    @input="selectedOutdoorModelErrors()"
                    name="outdoorSample"
                    ref="outdoorSampleField"
                    @keyup.enter="onOutdoorEnter()"
                    v-model="outdoorSample"
                    v-validate="'max:35'"
                    @click="showOutdoorSampleSelect = true"
                    placeholder="Select"
                    readonly
                    class="input"
                  />
                  <img
                    src="../../images/shared/drop.png"
                    alt="#"
                    class="drop-down-icone"
                  />
                  <ul
                    class="dropDown-indoor"
                    v-show="showOutdoorSampleSelect === true"
                    v-on:focusout="closeOutdoorSampleSelect()"
                  >
                    <li
                      id="outdoor-dropDown-item_1"
                      class="dropDown-item-indoor"
                      @click="setOutdoorItem('Front Entrance', 'outdoorSample')"
                    >
                      <span>Front Entrance</span>
                    </li>
                    <li
                      id="outdoor-dropDown-item_2"
                      class="dropDown-item-indoor"
                      @click="setOutdoorItem('Back Entrance', 'outdoorSample')"
                    >
                      <span>Back Entrance</span>
                    </li>
                    <li
                      id="outdoor-dropDown-item_3"
                      class="dropDown-item-indoor"
                      @click="setOutdoorItem('Side Entrance', 'outdoorSample')"
                    >
                      <span>Side Entrance</span>
                    </li>
                    <li
                      id="outdoor-dropDown-item_4"
                      class="dropDown-item-indoor"
                      @click="setOutdoorItem('Balcony', 'outdoorSample')"
                    >
                      <span>Balcony</span>
                    </li>
                    <li class="dropDown-item-indoor">
                      <input
                        type="text"
                        v-model="outdoorSample"
                        v-validate="'max:35'"
                        @change="changeVal('outdoorSample', $event, 0)"
                        class="dropDownInput"
                        @keyup.enter="closeOutdoorSampleSelect()"
                        placeholder="Enter Other Description"
                      />
                    </li>
                  </ul>
                  <div class="out-errors out-validate-errors" v-if="outdoorSample && outdoorSample.length > 35" >
                    Outdoor Sample may not exceed 35 characters.
                  </div>
                </div>
                <span v-else>
                  {{ kit.outdoor_sample }}
                </span>
                </div>
                <div class="row-item-out">
                    <span
                      class="status darkgray"
                      v-if="kit.outdoor_problem &&(selectedStatus === 'analysis_failed' || selectedStatus === 'archive')"
                    >
                    <span class="toCapitalFirst">{{kit.outdoor_problem}}</span>
                    </span>
                    <span
                      v-for="(item, index) in kit.indoorSamples"
                      v-bind:key="item.kit_id"
                      v-else-if="kit.problem == 1"
                    >
                      <span v-if="report !== null && !!report[index + 1]">
                        <span
                          class="status darkgray"
                          v-if="
                            report[index + 1].status === -1 &&
                            (selectedStatus === 'analysis_completed' || selectedStatus === 'partially_failed' ||  selectedStatus === 'archive')
                          "
                          >
                          {{ item.type }} (<span class="toCapitalFirst">{{item.kitProblems.problem}}</span>)
                        </span>
                      </span>
                      <span  v-else-if="item.kitProblems !== null">
                        <span
                          class="status darkgray"
                          v-if="
                            (selectedStatus === 'analysis_failed' || selectedStatus === 'archive')
                          "
                          >
                          {{ item.type }} (<span class="toCapitalFirst">{{item.kitProblems.problem}}</span>)
                          </span>

                      </span>
                      <span v-if="index !== kit.kitProblems.length - 1 && item.kitProblems !== null">, </span>
                    </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="details">
          <div class="details-title">INDOOR SAMPLES</div>
          <div
            class="row"
            v-for="(item, index) in kit.indoorSamples"
            v-bind:key="item.kit_id"
          >
            <div class="row-item sample room">
              <span v-if="report !== null && !!report[index + 1]">
                <span
                  class="circle"
                  :class="[
                    {
                      darkgray:
                        report[index + 1].status === -1 &&
                        selectedStatus === 'partially_failed' ||
                        selectedStatus === 'analysis_completed'
                    },
                    {
                      green:
                        report[index + 1].status === 0 &&
                        selectedStatus === 'partially_failed' ||
                        selectedStatus === 'analysis_completed'
                    },
                    {
                      yellow:
                        report[index + 1].status === 1 &&
                        selectedStatus === 'partially_failed' ||
                        selectedStatus === 'analysis_completed'
                    },
                    {
                      orange:
                        report[index + 1].status === 2 &&
                        selectedStatus === 'partially_failed' ||
                        selectedStatus === 'analysis_completed'
                    },
                    {
                      red:
                        report[index + 1].status === 3 &&
                        selectedStatus === 'partially_failed' ||
                        selectedStatus === 'analysis_completed'
                    }
                  ]"
                ></span>
              </span>
              <span class="circle" v-else></span>
              Indoor Sample #{{ index + 1 }}
            </div>
            <div class="row-item" v-if="item.type">
              <div class="inputs-wrap small" v-on:mouseleave="closeSelect()" v-if="enableEdit" >
                <input
                  @input="selectedModelErrors()"
                  :name="'Indoor Sample #' + (index + 1)"
                  @keyup.enter="onEnter()"
                  v-model= "$data[`selectedSample${index + 1}`]"
                  v-validate="'max:35'"
                  @click="openDropdown(`show${item.id}`)"
                  placeholder="Select"
                  readonly
                  class="input"
                />
                <img
                  src="../../images/shared/drop.png"
                  alt="#"
                  class="drop-down-icone"
                />
              <ul
                  class="dropDown-indoor"
                  v-show="show1 === `show${item.id}`"

                >
                  <li
                    :id="`dropDown-item-indoor1_${index + 1}`"
                    class="dropDown-item-indoor"
                    @click="setItemSamples('Attic', `selectedSample${index + 1}`, 1, index+1)"
                  >
                    <span>Attic</span>
                  </li>
                  <li
                    :id="`dropDown-item-indoor2_${index + 1}`"
                    class="dropDown-item-indoor"
                    @click="setItemSamples('Basement', `selectedSample${index + 1}`, 2, index+1)"
                  >
                    <span>Basement</span>
                  </li>
                  <li
                    :id="`dropDown-item-indoor3_${index + 1}`"
                    class="dropDown-item-indoor"
                    @click="setItemSamples('Bathroom', `selectedSample${index + 1}`, 3, index+1)"
                  >
                    <span>Bathroom</span>
                  </li>
                  <li
                    :id="`dropDown-item-indoor4_${index + 1}`"
                    class="dropDown-item-indoor"
                    @click="setItemSamples('Crawlspace', `selectedSample${index + 1}`, 4, index+1)"
                  >
                    <span>Crawlspace</span>
                  </li>
                  <li
                    :id="`dropDown-item-indoor5_${index + 1}`"
                    class="dropDown-item-indoor"
                    @click="setItemSamples('Dining Room', `selectedSample${index + 1}`, 5, index+1)"
                  >
                    <span>Dining Room</span>
                  </li>
                  <li
                    :id="`dropDown-item-indoor6_${index + 1}`"
                    class="dropDown-item-indoor"
                    @click="setItemSamples('Garage', `selectedSample${index + 1}`, 6, index+1)"
                  >
                    <span>Garage</span>
                  </li>
                  <li
                    :id="`dropDown-item-indoor7_${index + 1}`"
                    class="dropDown-item-indoor"
                    @click="setItemSamples('Living Room', `selectedSample${index + 1}`, 7, index+1)"
                  >
                    <span>Living Room</span>
                  </li>
                  <li
                    :id="`dropDown-item-indoor8_${index + 1}`"
                    class="dropDown-item-indoor"
                    @click="setItemSamples('Master Bedroom', `selectedSample${index + 1}`, 8, index+1)"
                  >
                    <span>Master Bedroom</span>
                  </li>
                  <li
                    :id="`dropDown-item-indoor9_${index + 1}`" 
                    class="dropDown-item-indoor"
                    @click="setItemSamples('Utility Room', `selectedSample${index + 1}`, 9, index+1)"
                  >
                    <span>Utility Room</span>
                  </li>
                  <li
                    :id="`dropDown-item-indoor10_${index + 1}`"
                    class="dropDown-item-indoor"
                    @click="
                      setItemSamples('Water Heater Closet', `selectedSample${index + 1}`, 10, index+1)
                    "
                  >
                    <span>Water Heater Closet</span>
                  </li>
                  <li
                    :id="`dropDown-item-indoor11_${index + 1}`"
                    class="dropDown-item-indoor"
                    @click="
                      setItemSamples('Family Room', `selectedSample${index + 1}`, 11, index+1)
                    "
                  >
                    <span>Family Room</span>
                  </li>
                  <li class="dropDown-item-indoor">
                    <input
                      type="text"
                      v-model="$data[`selectedSample${index + 1}`]"
                      v-validate="'max:35'"
                        @change="changeVal(`selectedSample${index + 1}`, $event, 0)"
                      class="dropDownInput"
                      @keyup.enter="closeSelect()"
                      placeholder="Enter Other Description"
                    />
                  </li>
                </ul>
              </div>
              <span v-else>
                {{ item.type }}
              </span>
              <div class="inputs-wrap-error small">
                  <div class="out-validate-errors" v-if="$data[`selectedSample${index + 1}`] && $data[`selectedSample${index + 1}`].length > 35" >
                    Indoor Sample {{index + 1}} may not exceed 35 characters.
                  </div>
               </div>
            </div>
            <div class="row-item noData" v-else>No Data</div>
            <div class="row-item status">
              <div v-if="report !== null && !!report[index + 1]">
                <span
                  class="status darkgray"
                  v-if="
                    report[index + 1].status === -1 &&
                    (selectedStatus === 'partially_failed' || selectedStatus === 'analysis_completed' || selectedStatus === 'archive')
                  "
                  >
                  Unable To Process (<span class="toCapitalFirst">{{item.kitProblems.problem}}</span>)
                  </span>
                <span
                  class="status green"
                  v-if=" report[index + 1].status === 0 &&
                      (selectedStatus === 'partially_failed' || selectedStatus === 'analysis_completed' || selectedStatus === 'archive')
                  "
                  >Not Evident</span
                >
                <span
                  class="status yellow"
                  v-if="
                    report[index + 1].status === 1 &&
                    (selectedStatus === 'partially_failed' || selectedStatus === 'analysis_completed' || selectedStatus === 'archive')
                  "
                  >Slightly Evident</span
                >
                <span
                  class="status orange"
                  v-if="
                    report[index + 1].status === 2 &&
                    (selectedStatus === 'partially_failed' || selectedStatus === 'analysis_completed' || selectedStatus === 'archive')
                  "
                  >Moderately Evident</span
                >
                <span
                  class="status red"
                  v-if="
                    report[index + 1].status === 3 &&
                    (selectedStatus === 'partially_failed' || selectedStatus === 'analysis_completed' || selectedStatus === 'archive')
                  "
                  >Significantly Evident</span
                >
                <span
                  class="status"
                  v-if="
                    report[index + 1].status > 3 &&
                    (selectedStatus === 'partially_failed' || selectedStatus === 'analysis_completed' || selectedStatus === 'archive')
                  "
                  >N/A</span
                >
              </div>
              <div  v-else-if="item.kitProblems !== null">
                <span
                  class="status darkgray"
                  v-if="
                    (selectedStatus === 'partially_failed' || selectedStatus === 'analysis_failed' || selectedStatus === 'archive')
                  "
                  >
                  Unable To Process (<span class="toCapitalFirst">{{item.kitProblems.problem}}</span>)
                  </span>

              </div>
              <div v-else-if="report === null">
                <span v-if="selectedStatus !== 'shipped' && selectedStatus !== 'archive'  && selectedStatus !== 'analysis_failed'" class="status"
                  >In Progress</span
                >
                <span v-else-if="selectedStatus === 'archive' || selectedStatus === 'analysis_failed' || selectedStatus === 'analysis_completed'" class="status">N/A</span>
              </div>
            </div>
          </div>
          <div class="inputs-wrap-error small">
                <div class="validate-errors"  v-if="errorMessage !== ''">
                      <span v-html="errorMessage"></span>
                </div>
          </div>
        </div>
        <div class="btns-complate-wrap" id="btns-complate-wrap">
          <div
            class="download-wrap"
            v-show="
              kit.status === 'analysis_completed' ||
              kit.status === 'partially_failed' ||
                kit.status === 'on_hold' ||
                kit.status === 'lab_received' ||
                kit.status === 'analysis_failed'
            "
          >
            <button
              class="download-link download-link-btn"
              title="Download"
              id="download_pdf"
              v-if="kit.status === 'analysis_completed' || kit.status === 'partially_failed' "
              @click.prevent="getFile"
            >
              <span class="download">
                <img src="../../images/dashboard/download.svg" alt="#" />
              </span>
              <span class="download-txt">Download full report (PDF)</span><br />
            </button>
            <span class="download-link span" title="Download" v-if="role === 'superadmin'">
              <input
                class="download-input"
                id="upload_csv"
                ref="file"
                @change="handleFileUpload()"
                type="file"
              />
              <label for="upload_csv" class="download upload_csv">
                <img
                  class="upload-img"
                  src="../../images/dashboard/download.svg"
                  v-if="start === 0"
                  alt="#"
                />
                <span class="timer" v-if="start > 0">{{ start }}</span>
              </label>
              <label for="upload_csv" class="download-txt upload_csv"
                >Upload CSV</label
              >
              <span class="uploadTxt">
                {{ uploadTxt }}
                <span class="error">{{ failUploadTxt }}</span>
              </span>
            </span>
            <a
              class="download-link"
              target="_blank"
              title="Download"
              :href="`${api_url}/v1/testkits/${kit.id}/report/csv`"
            >
              <span class="download">
                <img src="../../images/dashboard/download.svg" alt="#" />
              </span>
              <span class="download-txt">Download CSV</span>
              <span class="upload" v-if="upload !== null"
                >Uploaded: {{ convertDateUpload(upload) }}</span
              >
            </a>
          </div>
          <span
            class="download-txt non-downloading"
            :class="{ downloading: showPreloader }"
            >Waiting for download...</span
          >
          
        </div>
        <button
          class="btn save"
          v-show="kit.status === 'lab_awaiting'"
          @click="editDataSubmission"
          :disabled="errors.any() || !isComplete || validationError"
        >
          Save
        </button>
        <button
          class="btn save"
          v-show="kit.status !== 'lab_awaiting'"
          @click="editData"
          :disabled="errors.any() || !isComplete"
        >
          Save
        </button>
        <ConfirmShareKitStatus
        :KitInfo="kit"
        v-show="showShareStatus"
        @closeShareStatus="closeShareStatus"
        >
        </ConfirmShareKitStatus>
        <div class="saveTxt">{{ saveTxt }}</div>
        <Alert
          v-if="alertModal"
          :message = "message"
          @closeAlertModal="closeAlertModal"
        ></Alert>
      </div>
      <div v-show = "showLog"> 
        <DisplayLog></DisplayLog> 
      </div>
      <div class="download-wrap" v-show="kit.status === 'lab_awaiting' && !showLog">
        <div>
          <div id="download-button-wrap" class="btn-align"></div>
          <button
            class="download-link download-link-btn"
            title="Download"
            id="download_pdf"
            @click="downloadCsvFile"
            @click.stop="stopPropagation"
          >
            <span class="download">
              <img src="../../images/dashboard/download.svg" alt="#" />
            </span>
            <span class="download-txt">  Download Lab CSV</span><br />
          </button>
        </div>
      </div>
      <span
        class="download-txt non-downloading"
        :class="{ downloading: showPreloader }"
        >Waiting for download...</span
      >
      <template>
        <div class="resend-report-btn-wrap" v-show="!showLog">
          <a
            class="download-link"
            @click.prevent="resendLatestNotification(kit.id)"
          >
            <label class="download upload_csv">
              <img
                class="custom-mail"
                src="../../images/dashboard/mail.png"
                alt="#"
              />
            </label>
            <label class="download-txt upload_csv">Resend Last Notice</label>
          </a>
        </div>
      </template>
    </div>
</template>

<script>
import moment from "moment";
import { mask } from "vue-the-mask";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import axios from "axios";
import { parseAndConvertKitId } from "../mixins/parseAndConvertKitId";
import CloseIcone from "../../images/shared/cancel";
import Alert from "./AdminAlert";
import Timelinenew from "./timeline/Timelinenew.vue";
import Datepicker from "vuejs-datepicker";
import ConfirmShareKitStatus from "./modal/ConfirmShareKitStatus.vue";
import DisplayLog from "./log/DisplayLog"

export default {
  name: "ModalDesc",
  mixins: [parseAndConvertKitId],
  directives: { mask },
  props: ["personalData", "emailErrorObj", "validationError"],
  data() {
    return {
      api_url: process.env.VUE_APP_API_URL,
      kit: {},
      dateError: false,
      report: null,
      showDropDown: false,
      showSelectDrop: false,
      selectedStatus: null,
      shipmentStatus:null,
      track_number:null,
      ship_method:null,
      wp_api_url: process.env.VUE_APP_WP_API_URL,
      order_number:null,
      orderKey:null,
      reportLink: null,
      upload: null,
      start: 0,
      convertedKitId: "",
      readonly: true,
      uploadTxt: "",
      failUploadTxt: "",
      indoorSamplesLength: 2,
      saveTxt: "",
      status: [0, 1, 2, 3, 4, 5],
      showPreloader: false,
      alertModal: false,
      report_forward_email: null,
      show1:"",
      showOutdoorSampleSelect: false,
      selectedOutdoorModelError: true,
      title:"",
      sampling_date:"",
      address:"",
      indoorSamples_type:"",
      outdoorSample: "",
      selectedModel: "Near Front Entrance",
      selectedSample1: "",
      selectedSample2: "",
      selectedSample3: "",
      customError:{},
      errorMessage:'',
      visible_mold: false,
      musty_damp_odor: false,
      symptoms: false,
      disabledIds: [],
      indoorSamples: [],
      enableEdit:false,
      showShareStatus:false,
      message:null,
      showLog:false
    };
  },
  components: {
    CloseIcone,
    Alert,
    Timelinenew,
    Datepicker,
    ConfirmShareKitStatus,
    DisplayLog
  },
  methods: {
    ...mapActions([
      "sendNewData",
      "dowanloadReport",
      "clearInfo",
      "uploadCsv",
      "testKitInfo",
      "sendSearchReq",
      "resendNotification",
      "savereportemail",
      "saveUserSubmited",
      "getKitLog",
      "fetchServerTime"
    ]),
    toggleLog() {
      this.showLog = !this.showLog;
      if(this.showLog) {
        this.enableEdit = false;
       this.getKitLog(this.kit.id);
      }
    },
    stopPropagation(event) {
      event.stopPropagation();
    },
    async downloadCsvFile() {
      await axios({
        url: `${this.api_url}/v1/admin/downloadCsv/${this.kit.kit_id}`,
        method: "GET",
        responseType: "blob"
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${this.convertKitId(this.kit.kit_id)}.csv`
          );
          document.getElementById("download-button-wrap").appendChild(link);
          link.click();
        })
        .catch(errors => {
          this.message = 'problemWithSampleData';
          this.alertModal = true;
        })
    },
    editDetails() {
      this.enableEdit = true
      this.showLog = false;
      this.$emit("enableEdit", true);
    },
    cancelEdit() {
      this.enableEdit = false;
      this.$emit("enableEdit", false);
    },
    onOutdoorEnter() {
      this.showOutdoorSampleSelect = false;
      this.$validator.reset();
      this.selectedOutdoorModelErrors();
    },
    closeSelect() {
      this.show1 = "";
      this.selectedModelErrors();
    },
    closeOutdoorSampleSelect() {
      this.showOutdoorSampleSelect = false;
      this.selectedOutdoorModelErrors();
    },
    setOutdoorItem(txt, model) {
      this[model] = txt;
      this.showOutdoorSampleSelect = false;
      this.customError={};
      this.errorMessage = '';
      this.isSameCheck();
      this.$validator.reset();
      this.selectedOutdoorModelErrors();
    },
    selectedOutdoorModelErrors() {
      if(this.outdoorSample == "") {
        this.selectedOutdoorModelError = false;
      }
    },
    selectedModelErrors() {
      if (typeof this.kit.indoorSamples !== 'undefined' && this.checkSelectedData(this.kit.indoorSamples)) {
        this.selectedModelError = false;
      }
    },
    checkSelectedData(num) {
      for (let i = 1; i <= num; i++) {
        const sample = this[`selectedSample${i}`];
        if (!sample || sample.length > 35) {
          return false;
        }
      }

      return true;
    },
    openDropdown(el) {
      this.show1 === "" ? (this.show1 = el) : (this.show1 = "");
    },
    camelCaseVal(model, e, count) {
      if(count == 0 && e.target.value.length > 0){
        e.target.value = this.camelCapitalizeVal(e.target.value);
        e.target.style.textTransform = 'none';
      }
      if (model === "state") {
        this[model] =
          e.target.value.length <= 2
            ? e.target.value.toUpperCase()
            : e.target.value;
      } else {
        this[model] = e.target.value;
      }
    },
    capitalizeVal(input) {
      return input
        ? input.replace(/^\w{1,}|\w{4,}/g, function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
          })
        : input;
    },
    camelCapitalizeVal(input) {
      return input
        ? input
            .toLowerCase()
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.substring(1))
            .join(" ")
        : input;
    },
    showError(e) {
      this.sampling_date === ""
        ? (this.dateError = true)
        : (this.dateError = false);
    },
    formatDate(date) {
      return moment(date).format("MMMM D, YYYY");
    },
    changeVal(model, e, count) {
      if (count == 0 && e.target.value.length > 0){
        e.target.value = this.capitalizeVal(e.target.value);
        e.target.style.textTransform = 'none';
      }
      if (model.startsWith("selectedSample")) {
        this.$validator.validate(`Indoor Sample #${model.substr(14)}`);
        this[model] = e.target.value;
      } else if (model === "outdoorSample") {
        this.$validator.validate('outdoorSample');
        this[model] = e.target.value;
      } else if (model === "state") {
        this[model] =
          e.target.value.length <= 2
            ? e.target.value.toUpperCase()
            : e.target.value;
      } else {
        this[model] = e.target.value;
      }
      if (model.startsWith("selectedSample") || model === "outdoorSample") {
        this.customError = {};
        if (e.target.value != null && e.target.value.trim() != '') {
          this[model] = e.target.value;
          this.errorMessage = '';
          this.isSameCheck();
        }
      }
    },
    async getFile() {
      this.showPreloader = true;
      await axios({
        url: `${this.api_url}/v1/testkits/${this.kit.id}/report/pdf`,
        method: "GET",
        responseType: "blob" // important
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `KIT-ID-${this.convertKitId(this.kit.kit_id)}.pdf`
        );
        document.getElementById("btns-complate-wrap").appendChild(link);
        link.click();
      })
      .then(() => (this.showPreloader = false));
    },
    callPrint() {
      window.print();
    },
    showDropDownFn() {
      if (this.role === "superadmin") {
        this.showDropDown = !this.showDropDown;
        this.showSelectDrop = false;
      }
    },
    showSelectDropFn() {
      if (this.role === "superadmin") {
        this.showSelectDrop = !this.showSelectDrop;
      }
    },
    setItem(item) {
      const status = [
        "shipped",
        "activated",
        "lab_awaiting",
        "lab_received",
        "on_hold",
        "analysis_completed",
        "delivered",
      ];
      this.selectedStatus = status[item];
      this.showDropDown = false;
      this.showSelectDrop = false;
    },
    setItemSamples(txt, model, id, index) {
      this[model] = txt;
      this.show1 = "";
      this.customError={};
      this.errorMessage = '';
      this.isSameCheck();

      var element1 = document.getElementById('dropDown-item-indoor'+id+'_1');
      var element2 = document.getElementById('dropDown-item-indoor'+id+'_2');
      var element3 = document.getElementById('dropDown-item-indoor'+id+'_3');

      if(this.disabledIds[index]) {
        var existingElement1 = document.getElementById('dropDown-item-indoor'+this.disabledIds[index]+'_1');
        var existingElement2 = document.getElementById('dropDown-item-indoor'+this.disabledIds[index]+'_2');
        var existingElement3 = document.getElementById('dropDown-item-indoor'+this.disabledIds[index]+'_3');

        if(existingElement1) {
          existingElement1.classList.remove("disabled");
        }
        if(existingElement2) {
          existingElement2.classList.remove("disabled");
        }
        if(existingElement3) {
          existingElement3.classList.remove("disabled");
        }
      }

      if(element1) {
        element1.classList.add("disabled");
      }
      if(element2) {
        element2.classList.add("disabled");
      }
      if(element3) {
        element3.classList.add("disabled");
      }
      this.disabledIds[index] = id;
      this.$validator.reset();
      // this.selectedModelError = false;
      this.selectedModelErrors();
    },
    isSameCheck(){
      let samples = ['selectedSample1','selectedSample2','selectedSample3','outdoorSample'];
      samples.forEach((sample) => {
        let currentValue = this[sample];
        if (currentValue !== null) {
          for (let i = 1; i <= 3; i++) {
            let indoorSample = this['selectedSample' + i];
            if (indoorSample !== null && indoorSample !== "" && sample !== 'selectedSample' + i && currentValue.toUpperCase() === indoorSample.toUpperCase()) {
              let key = indoorSample.toUpperCase();
              if (!this.customError[key]) {
                this.customError[key] = [];
              }
              if (!this.customError[key].includes(`Sample ${i}`)) {
                this.customError[key].push(`Sample ${i}`);
              }
            }
          }
          if (this.outdoorSample !== null && this.outdoorSample !== "" &&  sample != 'outdoorSample' && currentValue.toUpperCase() === this.outdoorSample.toUpperCase()) {
            let key = this.outdoorSample.toUpperCase();

            // Check if key already exists in customError and if not, create a new array for that key
            if (!this.customError[key]) {
              this.customError[key] = [];
            }

            if (!this.customError[key].includes(`Outdoor Sample`)) {
              this.customError[key].push(`Outdoor Sample`);
            }
          }
        }
      });
    },
    handleFileUpload() {
      const formData = new FormData();
      const blod = new Blob([this.$refs.file.files[0]], { type: "text/csv" });
      formData.append("filename", blod);
      this.uploadCsv({ id: this.kit.id, data: formData })
        .then(res => {
          this.sendSearchReq();
          this.start = 5;
          const timer = setInterval(() => {
            if (this.start > 0) {
              this.start -= 1;
            } else {
              this.uploadTxt = "CSV successfully parsed";
              this.failUploadTxt = "";
              clearTimeout(timer);
            }
          }, 1000);
          setTimeout(res => {
            this.testKitInfo(this.kit.id);
          }, 5000);
        })
        .catch(err => {
          this.failUploadTxt = "Uploaded bad CSV";
          this.uploadTxt = "";
        });
    },
    resendLatestNotification(kit_id) {
      const data = {
        kit_id: kit_id,
      };
      this.resendNotification(data).then(res => {
        if(res.data) {
          this.message = "Notice Resent.";
        } else {
          this.message = "No email address found.";
        }
        this.alertModal = true;
      });
    },
    closeAlertModal(boolean) {
      this.alertModal = boolean;
    },
    showComment() {
      this.$emit("showComment", {
        txt: this.kit.reason_on_hold,
        show: true,
        id: this.kit.id
      });
    },
    closeModel(e) {
      if (this.showDropDown) {
        this.showDropDown = false;
      }
    },
    closeDropDown(e) {
      if (this.showSelectDrop) {
        this.showSelectDrop = false;
      }
    },
    editData() {
      const data = {
        kit_id: this.parseKitId(this.convertedKitId),
        collected_first_name: this.personalData.firstName,
        collected_last_name: this.personalData.lastName,
        status: this.selectedStatus,
        indoor_samples: this.kit.indoorSamples,
        collected_email: this.personalData.email
      };
      this.sendNewData({ data, id: this.kit.id }).then(res => {
        if(res.status == 'on_hold') {
          this.showComment();
        }
        this.saveTxt = "Data successfully saved";
      });
    },
    editDataSubmission() {
      const indoorSamples = [];
      this.kit.indoorSamples.forEach((item, index) => {
        const selected = `selectedSample${item.sample_order}`;
        indoorSamples.push({
          created_at:item.created_at,
          type: this[selected],
          id: item.id,
          sample_order:item.sample_order,
          testkit_id: item.testkit_id,
          updated_at:item.updated_at,
        });
      });
      const data = {
        kit_id: this.parseKitId(this.convertedKitId),
        collected_first_name: this.personalData.firstName,
        collected_last_name: this.personalData.lastName,
        status: this.selectedStatus,
        indoor_samples: indoorSamples,
        collected_email: this.personalData.email,
        title : this.title,
        sampling_date : this.sampling_date,
        address : this.address,
        visible_mold : this.visible_mold,
        musty_damp_odor : this.musty_damp_odor,
        symptoms : this.symptoms,
        outdoorSample : this.outdoorSample
      };
      if (typeof this.personalData.testkit !== 'undefined') {
        this.saveUserSubmited(this.personalData.testkit).then(res => {
          this.cancelEdit();
        });
      }
      this.sendNewData({ data, id: this.kit.id }).then(res => {
        if(res.status == 'on_hold') {
          this.showComment();
        }
        this.saveTxt = "Data successfully saved";
      });
    },
    closeModal() {
      this.clearInfo();
      this.$emit("closeModal", false);
    },
    shareStatus(){
      this.showShareStatus = true;
    },
    closeShareStatus(boolean) {
      this.showShareStatus = boolean;
    },
    date(localDate) {
      if (localDate !== null && typeof(localDate) !== "undefined") {
        var todayDate = localDate.slice(0, 10);
        let d = todayDate.split("-");
        let dates = d[1] + '/' + d[2] + '/' + d[0];
        return dates;  
      }
    },
    convertDateUpload(date) {
      if (date !== null) return moment(date).format("MMMM Do, YYYY");
    },
    savereportemails() {
      const data = {
        report_forward_email: this.report_forward_email,
        kit_id: this.kit.kit_id,
        status: this.selectedStatus
      };
      this.savereportemail(data).then(res => {
       this.report_forward_email = this.report_forward_email;
      });
    }
  },
  mounted() {
    this.kit = this.$store.getters.getTestKitInfo;
    if(this.$store.getters.getTestKitInfo != null) {
      this.selectedStatus = this.$store.getters.getTestKitInfo.status;
      if(typeof this.$store.getters.getTestKitInfo.shipmentStatus !== 'undefined' && this.$store.getters.getTestKitInfo.shipmentStatus !== '') {
        this.shipmentStatus = this.$store.getters.getTestKitInfo.shipmentStatus;
      } 
      this.track_number = this.$store.getters.getTestKitInfo.track_number;
      this.ship_method = this.$store.getters.getTestKitInfo.ship_method;
      this.orderKey = this.$store.getters.getTestKitInfo.orderKey;
      this.order_number = this.$store.getters.getTestKitInfo.order_number;
      this.indoorSamplesLength = this.kit.indoorSamples.length;
      this.title = this.kit.title;
      this.outdoorSample = this.kit.outdoor_sample;
      this.sampling_date = this.kit.sampling_date;
      this.address = this.kit.address;
      this.visible_mold = this.kit.visible_mold;
      this.musty_damp_odor = this.kit.musty_damp_odor;
      this.symptoms = this.kit.symptoms;
      
      if(this.kit.indoorSamples.length > 0){
        this.kit.indoorSamples.forEach(samples => {
          this['selectedSample'+samples.sample_order] = samples.type;
        });
      }
      if (this.$store.getters.getTestKitInfo.report) {
        this.report = this.$store.getters.getTestKitInfo.report.reportSamples;
        this.upload = this.$store.getters.getTestKitInfo.reported_at;
      }
      if(this.$store.getters.getTestKitInfo.report_forward_email) {
        this.report_forward_email = this.$store.getters.getTestKitInfo.report_forward_email;
      } else {
        this.report_forward_email = "N/A";
      }
      this.convertedKitId = this.convertKitId(this.kit.kit_id);
    }
  },
  inject: ["$validator"],
  computed: {
    ...mapGetters(["getTestKitInfo", "role", "serverValidation"]),
    isComplete() {
      return (
        this.convertedKitId,
        this.outdoorSample &&
        Object.keys(this.customError).length == 0 &&
        typeof this.indoorSamples !== 'undefined' &&
        this.checkSelectedData(this.indoorSamples.length)
      );
    },
    serverTime() {
       const time = this.$store.getters.getServerTime;
       return time ? new Date(time) : new Date();
    }
  },
  watch: {
    customError(obj){
      if (Object.keys(obj).length == 0) {
        return ''; // No error message if customError is empty
      } else {
        this.errorMessage = "";
        Object.entries(obj).forEach(([key, item]) => {
          item.sort((a, b) => {
            // Handle 'outdoor sample' specially to ensure it comes last
            if (a === 'Outdoor Sample') return 1;
            if (b === 'Outdoor Sample') return -1;

            // Extract the number from the string (assuming the number is always at the end)
            const aNumber = parseInt(a.split(' ').pop());
            const bNumber = parseInt(b.split(' ').pop());

            // Compare the extracted numbers
            return aNumber - bNumber;
          });

          // Multiple items error message
          let  itemsExceptLast = '';
          if (item.length > 2) {
            itemsExceptLast = item.slice(0, -1).join(', ') + ', and ' + item[item.length - 1];
          } else if (item.length > 0) {
            itemsExceptLast = item.join(' and ');
          } 

          // Format the error message
          this.errorMessage = this.errorMessage + `${itemsExceptLast} may not be the same name. <br>`;
          //  console.log(errorMessage);
          //  return errorMessage; // Output or store the error message as needed
        });
      }
    },
    getTestKitInfo(obj) {
      this.kit = obj;
      this.selectedStatus = obj.status;
      this.indoorSamplesLength = this.kit.indoorSamples.length;
      if (obj.report) {
        this.report = obj.report.reportSamples;
        this.upload = obj.reported_at;
      } else {
        this.report = null;
        this.upload = null;
      }
      this.convertedKitId = this.convertKitId(this.kit.kit_id);
    },
    serverValidation(error) {
      error.forEach(item => {
        this.$validator.errors.add({ field: item.field, msg: item.message });
      });
    }
  },
  created() {
    this.fetchServerTime();
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/colors";
.toCapitalFirst {
  text-transform: capitalize;
}
.filter-wrap {
  position: relative;
}
.filter-list-wrap {
  position: absolute;
  right: 314px;
  top: 23px;
  width: 160px;
  background-color: #fff;
  box-shadow: 0px 0px 5px 1px rgba(152, 164, 174, 0.4);
  z-index: 2;
}
.filter-list-item {
  padding: 10px;
  font-size: 13px;
  color: #000;
  font-family: TTNormsLight, sans-serif;
  transition: all 0.5s linear;
  cursor: pointer;
}
.filter-list-item:hover {
  background-color: #e0e9f4;
}
.filter-list-item.hide {
  padding: 10px;
  font-size: 12px;
  color: #b3b3b3;
  font-family: TTNormsMedium, sans-serif;
  cursor: default;
}
.filter-list-item.hide:hover {
  background-color: #fff;
}
.filter-list-item.active {
  font-family: TTNormsMedium, sans-serif;
  color: #005eb8;
}
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  border: 1px solid transparent;
  cursor: pointer;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
}
.print-btn {
  width: 90px;
  height: 30px;
  background-color: #1546ad;
  color: #fff;
  border-radius: 5px;
  outline: none;
  border: none;
  cursor: pointer;
}
.print-btn-email {
  width: 70px;
  height: 20px;
  background-color: #1546ad;
  color: #fff;
  border-radius: 5px;
  outline: none;
  border: none;
  cursor: pointer;
  margin-left: 10px;
}
.status-wrap {
  position: relative;
}
.com {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 25px 30px;
  position: relative;
  overflow-y: scroll;
}
.id {
  color: #231f20;
  text-align: right;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  max-width: 260px;
  width: 100%;
  font-family: TTNormsLight, sans-serif;
}
.id span {
  display: inline-block;
}
.title {
  color: #1052b2;
  padding: 20px 0 0 0;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  margin: 0 0 30px 0;
  display: flex;
  position: relative;
  justify-content: space-between;
}
.date-wrap {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #d9d9d9;
}
.proj-wrap {
  display: flex;
  justify-content: space-between;
}
.col {
  width: 50%;
}
.item {
  margin: 0 0 25px 0;
  position: relative;
}
.item-title {
  margin: 0 0 14px 0;
  color: #000;
  font-size: 12px;
  font-family: TTNormsMedium, sans-serif;
}
.item-val {
  color: #000;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  position: relative;
  display: flex; 
}
.item-val-span {
  display: flex;
  align-items: center;
  max-width: 200px;
  color: #000;
  cursor: pointer;
  width: 100%;
}
.item-val-span.hold {
  max-width: 100px;
}
.location {
  padding: 30px 0;
  border-bottom: 1px solid #d9d9d9;
  display: flex;
  justify-content: space-between;
}
.location .item-val {
  max-width: 300px;
  word-break: break-all;
  line-height: 1.3;
  width: 100%;
}
.location .item {
  margin: 0;
}
.details {
  padding: 28px 0;
  position: relative;
}
.btns-wrap {
  position: absolute;
  right: 5px;
  top: -11px;
  display: flex;
  justify-content: center;
  margin: 0 20px 0 0;
}
.row {
  display: flex;
  justify-content: space-between;
  margin: 0 0 28px 0;
}
.row:last-child {
  margin: 0;
}
.row-item {
  width: 30%;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.row-item-out {
  width: 50%;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.row-item.room {
  font-family: TTNormsMedium, sans-serif;
}
.btn {
  outline: none;
  border: 1px solid transparent;
  color: #fff;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  background-color: #6cc24a;
  width: 300px;
  height: 45px;
  border-radius: 30px;
  margin: 10px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.btn.save {
  margin: 55px auto 0 auto;
  width: 140px;
  transition: all 0.5s linear;
}
.btn.save:disabled {
  background-color: rgba(108, 194, 74, 0.2);
}
.dropDown {
  display: block;
  position: absolute;
  top: 0px;
  left: 0;
  width: 80%;
  z-index: 10;
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  border-top: 1px solid #e5e5e5;
}
.dropDown-item {
  display: none;
  background-color: #fff;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  cursor: pointer;
  text-align: center;
  pointer-events: none;
  color: #4f4e4e;
}
.dropDown-item.undisabled {
  pointer-events: auto;
  display: list-item;
}
.dropDown-item span {
  display: block;
  width: 100%;
  padding: 10px 0px;
}
.dropDown-item span:hover {
  background-color: #eaeaea;
}
.circle.darkgray {
  background-color: #333333;
}
.circle.cyan {
  background-color: #00FFFF;
}
.circle.green {
  background-color: green;
}
.circle.red {
  background-color: red;
}
.circle.orange {
  background-color: orange;
}
.circle.purple {
  background-color: #ac75bd;
}
.circle.yellow {
  background-color: gold;
}
.circle.blue {
  background-color: #03409a;
}
.circle.skyblue {
  background-color: #00BBDC;
}
.circle.dark-grey {
  background-color: #415c61;
}
.status {
  color: #cccdcf;
}
.status.darkgray {
  color: #333333;
}
.status.green {
  color: green;
}
.status.red {
  color: red;
}
.status.orange {
  color: orange;
}
.status.purple {
  color: #ac75bd;
}
.status.skyblue {
  color: #00BBDC;
}
.status.yellow {
  color: gold;
}
.circle {
  display: inline-block;
  margin: 0 5px 0 0;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: #cccdcf;
}
.item-val-img {
  max-width: 12px;
  margin: 0 0 0 10px;
}
.details-title {
  position: absolute;
  left: 212px;
  color: #999;
  font-size: 12px;
  font-family: TTNormsRegular, sans-serif;
  top: -6px;
  padding: 0 20px;
  background-color: #fff;
}
.download {
  width: 30px;
  height: 30px;
  background-color: #03409a;
  border-radius: 100%;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}
.download img {
  max-width: 12px;
  height: auto;
  cursor: pointer;
}
.kit-input {
  padding: 0px 5px;
  border: 1px solid transparent;
  outline: none;
  color: #231f20;
  font-size: 14px;
  margin: 0 0 0 5px;
  display: inline-block;
  max-width: 200px;
  width: 100%;
  transition: border 0.3s linear;
  font-family: TTNormsLight, sans-serif;
}
.kit-input.input {
  text-align: center;
}
.download-txt {
  font-size: 14px;
  color: #03409a;
  padding: 0 0 0 5px;
  font-family: GothamPro, sans-serif;
}
.non-downloading {
  opacity: 0;
}
.downloading {
  opacity: 1;
  margin-left: 35px;
  font-size: 10px;
  color: #6cc24a;
}
.download-link {
  display: flex;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  margin: 0 50px 0 0;
}
.download-link-btn {
  text-align: left;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}
.download-link.span {
  max-width: 135px;
  cursor: pointer;
}
.upload {
  position: absolute;
  bottom: -15px;
  color: #999999;
  font-size: 12px;
  width: 120%;
  left: 45px;
  font-family: TTNormsLight, sans-serif;
}
.download-wrap {
  display: flex;
  width: 100%;
  padding: 20px 0 0 0;
  border-top: 1px solid #e5e5e5;
  justify-content: flex-start;
}
.upload-img {
  transform: rotate(180deg);
}
.download-input {
  z-index: -1;
  width: 0;
  height: 0;
  outline: none;
  opacity: 0;
}
.upload_csv {
  cursor: pointer;
}
.noData {
  color: #999;
}
.onhold-btn {
  cursor: pointer;
  background-color: transparent;
  border: none;
  padding: 0;
  max-width: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  position: absolute;
  left: 110px;
  top: -5px;
}
.onhold-btn-img {
  max-width: 100%;
}
.share-btn-img {
  max-width: 50%;
}
.share-span{
  display: flex;
  width: 100%;
  max-width: 60px;
  cursor: pointer;
}
.onhold-btn-img {
  max-width: 100%;
}
.uploadTxt {
  position: absolute;
  color: green;
  width: 150%;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  bottom: -20px;
  left: 0;
}
.saveTxt {
  color: green;
  margin: 10px 0 0 0;
  text-align: center;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.timer {
  color: #fff;
  font-family: TTNormsRegular, sans-serif;
  font-size: 13px;
}
.answer {
  font-weight: 700;
  padding: 0 20px 0 5px;
}
.error {
  color: red;
}
@media (max-height: 790px) {
  .com {
    padding: 15px 30px;
  }
  .btn.save {
    margin: 30px auto 0 auto;
  }
}
@media print {
  .com {
    position: absolute;
    top: 50px;
  }
  .close,
  .print-btn,
  .btns-complate-wrap,
  .btn.save {
    display: none;
  }
}
.resend-report-btn-wrap {
  display: flex;
  align-items: center;
  margin-left: 4px;
}
.custom-mail {
  max-width: 15px !important;
}
.answers-border {
  border-bottom: 1px solid #d9d9d9;
}

.datepickerWrapDiv {
  width:300px;
}
.input {
  border-radius: 10px;
  padding: 15px 20px;
  color: $gray;
  width: 285px;
  font-size: 16px;
  border: 1px solid #ccc;
  text-align: center;
  outline: none;
  margin: 0;
  font-family: TTNormsMedium, sans-serif;
}
.input::placeholder {
  color: $lightGray;
  font-size: 16px;
}
.input-wrap {
  margin: 0 0 15px;
}
.input.invalid {
  border: 1px solid $red;
}
.input-wrap.small {
  width: 100%;
}
.input-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .inputs-wrap {
    width: 100%;
  }
}
.inputs-wrap {
  margin: 0 0 5px;
  position: relative;
}
.inputs-wrap.small {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}

.inputs-wrap.outdoor {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 285px;
}

.drop-down-icone{
  position: absolute;
  right: 20px;
  top: 65%;
  height: auto;
}

.drop-down-icone {
  position: absolute;
  right: 20px;
  top: 65%;
  height: auto;
  pointer-events: none;
}
.dropDown-indoor {
  display: block;
  position: absolute;
  top: 44px;
  left: 0;
  width: 100%;
  z-index: 10;
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  border-top: 1px solid transparent;
}
.dropDown-item-indoor {
  background-color: #fff;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  cursor: pointer;
  text-align: center;
  color: #4f4e4e;
}
.dropDown-item-indoor span {
  display: block;
  width: 100%;
  padding: 10px 0px;
}
.dropDown-item-indoor span:hover {
  background-color: #eaeaea;
}
.dropDownInput {
  padding: 10px;
  color: #4d4d4d;
  width: 100%;
  font-size: 14px;
  text-align: center;
  font-family: TTNormsLight, sans-serif;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-bottom: 1px solid transparent;
  border-top: 1px solid #e5e5e5;
}
.dropDownInput::placeholder {
  color: #98a4ae;
}
.checkbox-items-wrap {
  display: flex;
  justify-content: center;
  margin-right: 10px;
  margin-left: 10px;
}
.label-checkbox {
  display: flex;
  align-items: center;
  position: relative;
}
.checkbox {
  opacity: 0;
  width: 100%;
  margin: 0;
  height: 100%;
  z-index: 1;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
}
.checkbox-wrap {
  position: relative;
  width: 72px;
  height: 24px;
}

.checkbox-toggle-text {
  position: absolute;
  z-index: 2;
  color: $white;
  font-size: 11px;
  text-transform: uppercase;
  font-family: TTNormsMedium, sans-serif;
  top: 9px;
  left: 15px;
  cursor: pointer;
}
.checkbox-toggle-text-right {
  left: auto;
  right: 15px;
}
.slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  width: 100%;
  height: 100%;
  border-radius: 20px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 28px;
  width: 28px;
  left: 0;
  bottom: -2px;
  box-shadow: 0 0 2px 1px $boxShadow;
  background-color: $white;
  transition: 0.4s;
  border-radius: 100%;
}
.checkbox:checked + .slider {
  background-color: $green;
}

.checkbox:checked + .slider:before {
  transform: translateX(44px);
}
.button-container{
  display: flex; /* Use flexbox to align buttons horizontally */
  gap: 10px;
}
.disabled {
  pointer-events: none; 
  background-color: #e7e9eb; 
}
.inputs-wrap-error{
  margin: 20px 0 20px;
  width: 100%;
}
.validate-errors {
  color: $red;
  font-size: 13px;
  font-family: TTNormsLight, sans-serif;
  bottom: -15px;
  display: inline-block;
  left: 0;
  width: 100%;
  text-align: center;
}
.out-validate-errors {
  color: $red;
  font-size: 13px;
  font-family: TTNormsLight, sans-serif;
  bottom: -15px;
  display: inline-block;
  left: 0;
  width: 285px;
  text-align: center;
}
.out-errors {
  margin-top: 20px;
}
</style>
